const City = () =>
  import(
    /* webpackChunkName: "base-info-geo-city" */ '@/pages/base-info/geo/city/index.vue'
  )
const CreateCity = () =>
  import(
    /* webpackChunkName: "base-info-geo-city" */ '@/pages/base-info/geo/city/create.vue'
  )
const EditCity = () =>
  import(
    /* webpackChunkName: "base-info-geo-city" */ '@/pages/base-info/geo/city/edit.vue'
  )

export default {
  path: 'city',
  meta: {
    label: 'city',
    auth: 'city'
  },
  component: {
    name: 'City',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoGeoCity',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: City
    },
    {
      name: 'BaseInfoCreateGeoCity',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCity
    },
    {
      name: 'BaseInfoEditGeoCity',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCity,
      props: true
    }
  ]
}
